module.exports = "https://files.cnvos.si/static/images/sport.png?457ded922a88b585d636789118fcc542";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/sport.png
// module id = 125
// module chunks = 1 2